import { H1 } from '@liveauctioneers/hammer-ui-core/text';
import { useCallback, useRef } from 'react';

import { useIsMobileLayout } from '@/hooks';
import { OtherCategoriesDropDown } from '@/pages/DiscoverCategories/components/DiscoverCategories/components/OtherCategories/OtherCategoriesDropDown/OtherCategoriesDropDown';
import { DiscoverCategoriesSubcategory as SubCategory } from '@/pages/DiscoverCategories/components/DiscoverCategoriesSubcategory/DiscoverCategoriesSubcategory';
import DiscoverCategoriesMeta from '@/pages/DiscoverCategories/meta/DiscoverCategoriesMeta';
import { Category } from '@/pages/DiscoverCategories/types/CategoryTypes';
import { useAppSelector } from '@/redux/hooks';
import { getCategoryLoaded } from '@/redux/modules/category/category.selectors';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { OtherCategories } from './components/DiscoverCategories/components/OtherCategories/OtherCategories';
import { DropDown } from './components/DiscoverCategoriesDropDown/DropDown';
import { Sidebar } from './components/Sidebar/Sidebar';
import { CategoryNamesAndIds } from './constants/constant';

const DiscoverCategories = () => {
    const categoryRefs = useRef<HTMLDivElement[]>([]);

    const formatMessage = useAppFormatMessage();
    const isMobile = useIsMobileLayout();

    const scrollToCategory = useCallback((index: number) => {
        categoryRefs.current[index]?.scrollIntoView({ behavior: 'smooth' });
    }, []);
    const orderedCategoryIds = Object.values(CategoryNamesAndIds);
    const categoryNames = Object.keys(CategoryNamesAndIds);

    const categories = useAppSelector(getCategoryLoaded) as {
        [id: number]: Category[];
    };

    return (
        <div className="max-[1200px]:ml-0 max-[1200px]:min-h-[300px] max-[1200px]:max-w-full max-[1200px]:min-w-[55%] relative mx-auto flex min-h-[400px] max-w-[1240px] flex-col px-[20px] pb-2xl">
            <DiscoverCategoriesMeta />
            <div className="max-[560px]:block flex">
                <Sidebar
                    isMobile={isMobile}
                    scrollToCategory={scrollToCategory}
                />
                <div className="flex flex-col">
                    {isMobile && <H1 className="my-md">{formatMessage(['discoverPage', 'exploreCategories'])}</H1>}
                    {orderedCategoryIds.map((id, index) => {
                        if (id <= 0) {
                            return null;
                        }
                        return isMobile ? (
                            <DropDown
                                categories={Array.isArray(categories[id]) ? categories[id] : []}
                                index={index}
                                key={id}
                                title={categoryNames[index]}
                            />
                        ) : (
                            <SubCategory
                                category={Array.isArray(categories[id]) ? categories[id] : []}
                                key={id}
                                ref={(element) => {
                                    categoryRefs.current[index] = element;
                                }}
                                title={categoryNames[index]}
                            />
                        );
                    })}
                    {isMobile ? (
                        <OtherCategoriesDropDown />
                    ) : (
                        <OtherCategories
                            ref={(element) => {
                                categoryRefs.current[orderedCategoryIds.length] = element;
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default DiscoverCategories;
